import React, { Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import {
  LazyDigitalComplianceLabelPage,
  LazyPackagingLabelVerificationPage,
  LazyProductLabelVerificationPage,
} from './heavyRouteChunks'
import RouteChunkFallback from './RouteChunkFallback'

function PublicVerifyNotFound() {
  return (
    <div
      style={{
        padding: '2rem',
        textAlign: 'center',
        fontFamily: 'system-ui, sans-serif',
        color: '#2E2D2B',
      }}
    >
      <p>Label not found.</p>
    </div>
  )
}

export default function PublicVerifyRoutes() {
  return (
    <Suspense fallback={<RouteChunkFallback />}>
      <Routes>
        <Route
          path="/digital-compliance-label/:labelToken"
          element={<LazyDigitalComplianceLabelPage />}
        />
        <Route
          path="/l/package/:uuid"
          element={<LazyPackagingLabelVerificationPage />}
        />
        <Route
          path="/l/product/:uuid"
          element={<LazyProductLabelVerificationPage />}
        />
        <Route
          path="/:labelToken"
          element={<LazyDigitalComplianceLabelPage />}
        />
        <Route path="*" element={<PublicVerifyNotFound />} />
      </Routes>
    </Suspense>
  )
}
